import { render, staticRenderFns } from "./DocumentsInstructions.vue?vue&type=template&id=e8c74966&scoped=true"
import script from "./DocumentsInstructions.vue?vue&type=script&lang=js"
export * from "./DocumentsInstructions.vue?vue&type=script&lang=js"
import style0 from "./DocumentsInstructions.vue?vue&type=style&index=0&id=e8c74966&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c74966",
  null
  
)

export default component.exports